"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoundCheckbox = exports.Label = exports.ButtonContainer = exports.ButtonCheckboxContainer = exports.ButtonCheckbox = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../assets/styles/colors");
const ButtonContainer = styled_components_1.default.div `
  color: ${(props) => props.$isActive && !props.$isColorStatic ? colors_1.blue : colors_1.gray400};
  display: flex;
  align-items: center;
  gap: 1rem;
`;
exports.ButtonContainer = ButtonContainer;
const Label = styled_components_1.default.span `
  display: inline-block;
  align-items: center;

  &::first-letter {
    text-transform: capitalize;
  }
`;
exports.Label = Label;
const ButtonCheckboxContainer = styled_components_1.default.label `
  position: relative;
  display: inline-block;
  width: 18px;
  height: 18px;
`;
exports.ButtonCheckboxContainer = ButtonCheckboxContainer;
const ButtonCheckbox = styled_components_1.default.input `
  opacity: 0;
  width: 18px;
  height: 18px;
  position: absolute;
  z-index: 2;
  cursor: pointer;

  &:checked + span {
    background-color: ${colors_1.white};
    border-color: ${colors_1.blue};
  }

  &:checked + span:after {
    opacity: 1;
  }
`;
exports.ButtonCheckbox = ButtonCheckbox;
const RoundCheckbox = styled_components_1.default.span `
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${colors_1.gray100};
  transition: 0.4s;
  border-radius: 50%;
  border: 1px solid ${colors_1.gray200};
  min-width: 18px;

  &:after {
    border: 2px solid ${colors_1.blue};
    border-top: none;
    border-right: none;
    content: "";
    height: 6px;
    left: 3px;
    opacity: 0;
    position: absolute;
    top: 4px;
    transform: rotate(-45deg);
    width: 12px;
  }
`;
exports.RoundCheckbox = RoundCheckbox;
